import React from 'react'
import svgSprite from '!!raw-loader!images/sprite.svg'

export default function SvgSpriteSheet () {
  return (
    <div
      style={{
        height: 0,
        overflow: 'hidden',
        opacity: 0,
      }}
      dangerouslySetInnerHTML={{ __html: svgSprite }}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/util/SvgSpriteSheet.jsx